const translations = {
    synced: 'Synced'
};

export default translations;
